export const PAGE_IS_LOADING = "page/IS_LOADING"

export const USER_IS_SET = "auth/USER_IS_SET"

export const HAS_CREATED_DATABASE = "status/HAS_CREATED_DATABASE"